<template>
  <div class="swan-quality-inspection">
    <a-tabs type="card" v-model:activeKey="tabActivekey" @change="handleTabChange">
      <!-- <a-tab-pane
        key="summaryOfpassRate"
        tab="合格率汇总"
        v-if="meta['/inspection_passRate']"
      >
        <pass-rate :activeKey="tabActivekey"></pass-rate>
      </a-tab-pane>

      <a-tab-pane key="unqualified" tab="不合格率汇总">
        <a-tabs
          type="card"
          v-model:activeKey="pqcTabActivekey"
          @change="handleTabChange"
        >
          <a-tab-pane tab="年度汇总" key="summaryOfunqualified">
            <unqualified-statistics :activeKey="pqcTabActivekey">
            </unqualified-statistics>
          </a-tab-pane>

          <a-tab-pane tab="问题明细" key="summaryOfunqualifiedDetails">
            <unqualified-details :activeKey="pqcTabActivekey">
            </unqualified-details>
          </a-tab-pane>
        </a-tabs>
      </a-tab-pane> -->

      <template v-for="item in PQCProductOption" :key="item.value">
        <a-tab-pane :tab="item.label">
          <pqc-process :type="item.value" v-if="tabActivekey === item.value"></pqc-process>
        </a-tab-pane>
      </template>

      <!-- <a-tab-pane key="PQC" tab="PQC" v-if="meta['/inspection_QC_action']">
        <a-tabs
          type="card"
          v-model:activeKey="pqcTabActivekey"
          @change="handleTabChange"
        >
          <template v-for="item in PQCProductOption" :key="item.label">
            <a-tab-pane :tab="item.label">
              <pqc-process :type="item.label"></pqc-process>
            </a-tab-pane>
          </template>
        </a-tabs>
      </a-tab-pane>

      <a-tab-pane key="IQC" tab="IQC" v-if="meta['/inspection_IQC_action']">
        <iqc :deleteAuthority="meta['/inspection_delete']"></iqc>
      </a-tab-pane> -->
    </a-tabs>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, watch, provide } from "vue";
import iqc from "../../components/quality/IQC/index.vue";
import passRate from "../../components/quality/PassRate/index.vue";
import pqcProcess from "../../components/quality/PQC/view/index.vue";
import { useRoute } from "vue-router";
import {
  getProcessesColumns,
  handleSetColumns,
} from "@/views/productDaily/components/quality/PQC/serve/option";
import { getPQCProductOption } from "@/views/productDaily/serve/option";
import unqualifiedStatistics from "@/views/productDaily/components/quality/unqualified/index.vue";
import unqualifiedDetails from "@/views/productDaily/components/quality/unqualified/details.vue";

export default defineComponent({
  components: {
    iqc,
    passRate,
    pqcProcess,
    unqualifiedDetails,
    unqualifiedStatistics,
  },
  setup() {
    const tabActivekey = ref(null);
    const pqcTabActivekey = ref(null);

    provide("tabActivekey", tabActivekey);
    provide("pqcTabActivekey", pqcTabActivekey);

    const route = useRoute();

    const meta = reactive({
      "/inspection_IQC_action": false,
      "/inspection_QC_action": false,
      "/inspection_passRate": false,
      "/inspection_delete": false,
      "/inspection_QC_reasonOrSolution": false,
    });

    const pqcSetting = reactive({
      columns: getProcessesColumns(),
      name: "三大件",
      type: "三大件",
      produceOrTpc: null,
      // PQC FQC OQC 操作权限
      PFOAuthority: false,
      // 问题原因和解决方案 操作权限
      ROSAuthority: false,
    });

    const PQCProductOption = getPQCProductOption().filter(
      (f) => f.label !== "束腰" && f.label !== "绕光纤参考臂"
    );

    provide("pqcSetting", pqcSetting);

    const otherFQCcolumns = [
      {
        index: 0,
        column: {
          title: "总装调试SN号",
          dataIndex: "assembleDebugsnNumber",
          align: "center",
          width: 200,
        },
      },
    ];

    const otherOQCcolumns = [
      {
        index: 0,
        column: {
          title: "机身号",
          dataIndex: "serial",
          align: "center",
          width: 200,
        },
      },
    ];

    // 往指定的位置中插入
    const insertColumnsByIndex = (columns, list) => {
      list.forEach((item) => {
        const { index, column } = item;
        columns.splice(index, 0, column);
      });
    };

    const handleSetColumns = (type) => {
      const isChangeColumns = (process) =>
        process !== "oqc" && process !== "fqc";
      // 标签切换前和切换之后都不是oqc fqc 返回
      if (isChangeColumns(pqcSetting.type) && isChangeColumns(type)) return;

      if (!isChangeColumns(pqcSetting.type) && isChangeColumns(type)) {
        pqcSetting.columns = getProcessesColumns();
        return;
      }

      let columns = getProcessesColumns();

      if (type === "fqc") {
        insertColumnsByIndex(columns, otherFQCcolumns);
        columns = columns.filter(
          (f) =>
            f.title !== "SN号" &&
            f.title !== "输出SN号" &&
            f.title !== "创建时间" &&
            f.title !== "闭环状态" &&
            f.title !== "来源工序"
        );
      }

      if (type === "oqc") {
        insertColumnsByIndex(columns, otherOQCcolumns);
        columns = columns.filter(
          (f) =>
            f.title !== "SN号" &&
            f.title !== "输出SN号" &&
            f.title !== "创建时间" &&
            f.title !== "闭环状态" &&
            f.title !== "来源工序"
        );
      }

      pqcSetting.columns = columns;
    };

    const handleTabChange = (key) => {
      handleSetColumns(key);
      pqcSetting.type = key;
      pqcSetting.name = key;
    };

    watch(
      () => route.query,
      (val) => {
        if (val.meta) {
          const authority = JSON.parse(decodeURI(val.meta));
          Object.keys(authority).forEach((key) => {
            meta[key] = authority[key];
          });

          pqcSetting.PFOAuthority = meta["/inspection_QC_action"] || meta['/trail_inspection_action'];
          pqcSetting.ROSAuthority = meta["/inspection_QC_reasonOrSolution"] || meta['/trail_qc_reasonOrSolution'];
          pqcSetting.produceOrTpc = authority.produceOrTpc;

          tabActivekey.value = null;
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );
    return {
      meta,
      tabActivekey,
      pqcTabActivekey,
      PQCProductOption,
      handleTabChange,
    };
  },
});
</script>

<style lang="less" scoped>
.swan-quality-inspection {
  width: 100vw;
  height: 100vh;
  overflow-y: scroll;
  background: #fff;
  border-radius: 10px;
  padding: 20px;
}
</style>
